module.exports = __webpack_public_path__ + "static/img/case_detail_08_3.27ff81d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_08_3.png
// module id = GUEO
// module chunks = 34